import * as React from 'react';
import * as styles from './TimeStreamToolbox.scss';
import { ContextualMenu, IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { DirectionalHint } from '@fluentui/react/lib/Callout';
import { useBooleanState } from 'owa-react-hooks/lib/useBooleanState';
import { DragHandle } from 'owa-timestream-asset-sdk';
import { observer } from 'mobx-react-lite';
import { Icon } from '@fluentui/react/lib/Icon';
import { isCurrentCultureRightToLeft } from 'owa-localize';
import { shouldShowExpandedToolbox } from '../viewstate';
import getToolAriaLabel from '../util/getToolAriaLabel';

export default observer(function TimeStreamToolboxContextualMenu({
    title,
    getToolName,
    iconName,
    iconNameRTL,
    menuItems,
    showTitle,
    isDraggable,
    disabled,
}: {
    title?: string;
    getToolName?: () => string;
    iconName: string;
    iconNameRTL?: string;
    menuItems: IContextualMenuItem[];
    showTitle?: boolean;
    isDraggable?: boolean;
    disabled?: boolean;
}) {
    const buttonRef = React.useRef<HTMLButtonElement>(null);
    const [
        shouldShowContextualMenu,
        setShowContextualMenu,
        setHideContextualMenu,
    ] = useBooleanState(false);

    const toolName = title || (getToolName ? getToolName() : '');
    const isRTL = isCurrentCultureRightToLeft();
    const actualIconName = (isRTL && iconNameRTL) || iconName;
    const shouldShowTitle = showTitle || shouldShowExpandedToolbox();

    // We might want to show disabled buttons; for now let's just hide it.
    if (disabled) {
        return null;
    }

    return (
        <button
            ref={buttonRef}
            className={styles.toolContainer}
            title={toolName}
            onClick={setShowContextualMenu}
            role="menuitem"
            aria-label={getToolAriaLabel(toolName)}>
            <div className={styles.toolIcon}>
                {isDraggable && <DragHandle size={12} className={styles.dragHandle} />}
                <Icon iconName={actualIconName} />
            </div>
            {shouldShowTitle && <div className={styles.toolTitle}>{toolName}</div>}
            <ContextualMenu
                items={menuItems}
                hidden={!shouldShowContextualMenu}
                target={buttonRef}
                onItemClick={setHideContextualMenu}
                onDismiss={setHideContextualMenu}
                directionalHint={DirectionalHint.rightTopEdge}
                directionalHintForRTL={DirectionalHint.leftTopEdge}
            />
        </button>
    );
});
